var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6158 8.00613L22.675 16.1301L24.7072 11.3371L33.6158 8.00613Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38385 8.00609L19.2258 16.207L17.2924 11.337L8.38385 8.00609Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6832 26.8373L26.7723 31.3005L33.0006 33.0154L34.7801 26.9362L29.6832 26.8373Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23047 26.9362L8.99901 33.0154L15.2273 31.3005L12.3274 26.8373L7.23047 26.9362Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.887 19.2961L13.1514 21.9234L19.3248 22.1983L19.1161 15.5474L14.887 19.2961Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1126 19.2961L22.8176 15.4705L22.6748 22.1982L28.8482 21.9234L27.1126 19.2961Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2272 31.3006L18.9511 29.4867L15.7435 26.9803L15.2272 31.3006Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0484 29.4867L26.7722 31.3006L26.2559 26.9803L23.0484 29.4867Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7724 31.3005L23.0486 29.4867L23.3452 31.9162L23.3122 32.9385L26.7724 31.3005Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2275 31.3009L18.6877 32.9389L18.6657 31.9165L18.9513 29.487L15.2275 31.3009Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7537 25.3753L15.656 24.4629L17.842 23.4625L18.7537 25.3753Z",
    fill: "#181818",
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2463 25.3753L24.158 23.4625L26.3549 24.4629L23.2463 25.3753Z",
    fill: "#181818",
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2275 31.3005L15.7658 26.8373L12.3276 26.9363L15.2275 31.3005Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2343 26.8373L26.7725 31.3005L29.6835 26.9363L26.2343 26.8373Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8485 21.9234L22.675 22.1983L23.2463 25.3753L24.158 23.4625L26.3549 24.4629L28.8485 21.9234Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6561 24.4629L17.842 23.4625L18.7538 25.3753L19.325 22.1983L13.1516 21.9234L15.6561 24.4629Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1514 21.9236L15.7438 26.9804L15.6559 24.463L13.1514 21.9236Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3547 24.4628L26.2559 26.9802L28.8483 21.9234L26.3547 24.4628Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3246 22.1979L18.7534 25.3749L19.4784 29.1235L19.6322 24.1876L19.3246 22.1979Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6745 22.1978L22.3779 24.1765L22.5207 29.1234L23.2457 25.3748L22.6745 22.1978Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2464 25.3752L22.5214 29.1239L23.0487 29.4867L26.2562 26.9802L26.3551 24.4628L23.2464 25.3752Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.656 24.4628L15.7439 26.9802L18.9514 29.4867L19.4787 29.1239L18.7537 25.3752L15.656 24.4628Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3122 32.9385L23.3452 31.9162L23.0706 31.6743H18.9293L18.6657 31.9162L18.6877 32.9385L15.2275 31.3006L16.4358 32.2899L18.8964 33.9939H23.1035L25.5641 32.2899L26.7724 31.3006L23.3122 32.9385Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0487 29.4868L22.5214 29.124H19.4786L18.9514 29.4868L18.6658 31.9163L18.9294 31.6744H23.0706L23.3453 31.9163L23.0487 29.4868Z",
    fill: "#181818",
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0773 16.6577L35 12.1725L33.6159 8.00609L23.0486 15.8552L27.113 19.296L32.858 20.978L34.1212 19.4939L33.572 19.0982L34.4508 18.2957L33.7807 17.768L34.6595 17.0974L34.0773 16.6577Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.1726L7.9337 16.6578L7.34053 17.0976L8.2193 17.7681L7.54924 18.2958L8.42801 19.0983L7.87878 19.4941L9.14202 20.9781L14.887 19.2962L18.9514 15.8553L8.38407 8.00624L7 12.1726Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8577 20.9779L27.1127 19.2959L28.8482 21.9233L26.2559 26.9801L29.6831 26.9362H34.78L32.8577 20.9779Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8868 19.2959L9.14181 20.9779L7.23047 26.9362H12.3274L15.7436 26.9801L13.1512 21.9233L14.8868 19.2959Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6751 22.1983L23.0486 15.8553L24.7073 11.3371H17.2926L18.9513 15.8553L19.3248 22.1983L19.4676 24.1991L19.4786 29.124H22.5213L22.5323 24.1991L22.6751 22.1983Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.e6fdb7f1.svg";
export { ForwardRef as ReactComponent };